<template>
  <div class="notification-row">
    <friend-request-notification
      v-if="notification.type === NOTIFICATION_TYPES.NEW_FRIEND_REQUEST"
      :notification="notification"
      @friend-request-accepted="$emit('friend-request-accepted')"
    ></friend-request-notification>
    <accepted-friend-request-notification
      v-if="notification.type === NOTIFICATION_TYPES.ACCEPED_FRIEND_REQUEST"
      :notification="notification"
    ></accepted-friend-request-notification>
    <comment-notification
      v-else-if="notification.type === NOTIFICATION_TYPES.COMMENT"
      :notification="notification"
    ></comment-notification>
  </div>
</template>

<script>
import friendRequestNotification from "./friend-request-notification.vue";
import acceptedFriendRequestNotification from "./accepted-friend-request-notification.vue";
import commentNotification from "./comment-notification.vue";
import { NOTIFICATION_TYPES } from "../../util/constants";

export default {
  name: "notification-entry",

  props: {
    notification: Object,
  },

  components: { acceptedFriendRequestNotification, commentNotification, friendRequestNotification },

  data: () => ({
    NOTIFICATION_TYPES,
  }),
};
</script>

<style>
.notification-row {
  height: max(48px, auto);
  margin: 0 8px 12px;
}
.notification-row:last-of-type {
  margin-bottom: 0;
}

.notification-grid {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  column-gap: 16px;
}

.notification-grid profile-avatar {
  grid-column: 1;
}

.notification-message {
  grid-column: 2;
  align-self: center;
  font-size: 16px;
  line-height: 18px;
  text-wrap: balance;

  max-width: 1fr;
  overflow: hidden;
}

.notification-row .notification-message a {
  font-weight: 500;
  color: black;

  display: inline-block;
  max-width: 100%;
}

.notification-action {
  max-width: 100px;
  width: 100px;
  align-self: center;
}

.notification-action:nth-last-of-type(2) {
  grid-column: 3;
}

.notification-action:last-of-type {
  grid-column: 4;
}

.notification-action .v-btn__content {
  text-transform: lowercase;
}

.notification-timestamp {
  color: var(--text-middle-lightness);
  font-size: 12px;
  line-height: 13px;
}

@media (max-width: 600px) {
  .notification-row {
    margin-left: 0;
    height: max(32px, auto);
  }

  .notification-grid {
    column-gap: 8px;
  }

  .notification-message {
    font-size: 14px;
    line-height: 15px;
  }

  .notification-action {
    max-width: 68px;
  }
  .notification-action .v-btn__content {
    font-size: 12px;
  }
}
</style>
